import { PutSupplierHearingItemReq } from '@gateway.Supplier'
import { yamadumiApi } from '../yamadumi-api'

export class HearingItemGateway {
  /**
   * 業者ヒアリング(ヒアリングシート)-登録
   */
  static putHearingItem = async (
    params: PutSupplierHearingItemReq
  ) => {
    return await yamadumiApi.put('/api/supplier/hearing/sheet/item', params)
  }
}
